import fe_config from "constants/Configs";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { I18nextProvider } from "react-i18next";
import { PersistGate } from "redux-persist/integration/react";
import "./polyfills-buffer"; // Add Buffer polyfill first
import "./polyfills"; // Add require polyfill
import { AuthProvider } from "react-oidc-context";
import { getActiveUserManager } from "utils/oidcUserManager";
import { ThemeProvider } from "./context/ThemeContext";
import i18n from "./utils/localization/config";
import Root from "./routes";
import { store, persistedStore } from "./store";
import "assets/css/main.css";

/* eslint eqeqeq: "off", curly: "error" */

fe_config.MODE === "PROD" && (console.warn = console.error = () => {});
fe_config.MODE === "DEV" && (console.warn = () => {});

// Only run standalone mode when NOT loaded as a microfrontend
// Check if single-spa is controlling the app lifecycle
const isStandalone = !window.singleSpaNavigate;

if (isStandalone) {
  const bootstrap = async () => {
    const container = document.getElementById("root");
    const root = createRoot(container);

    root.render(
      <ThemeProvider>
        <I18nextProvider i18n={i18n}>
          <AuthProvider
            userManager={getActiveUserManager()}
            onSigninCallback={() =>
              window.history.replaceState(
                {},
                document.title,
                window.location.pathname
              )
            }
          >
            <Provider store={store}>
              <PersistGate persistor={persistedStore}>
                <Root i18n={i18n} />
              </PersistGate>
            </Provider>
          </AuthProvider>
        </I18nextProvider>
      </ThemeProvider>
    );
  };

  bootstrap();
}
